/* DreamCatcher mega menu: opens on hover (with a short delay so it doesn't flicker),
   on keyboard focus, and on first tap for touch screens. Escape and outside clicks close it. */
(function () {
  if (window.__dcMegaMenu) return;
  window.__dcMegaMenu = true;

  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 220;
  var desktop = window.matchMedia('(min-width: 990px)');
  var canHover = window.matchMedia('(hover: hover)');

  function allItems() {
    return document.querySelectorAll('[data-dc-mm]');
  }

  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var trigger = item.querySelector('.dc-mm__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    allItems().forEach(function (item) {
      if (item !== except && item.classList.contains('is-open')) setOpen(item, false);
    });
  }

  function anyOpen() {
    return document.querySelector('[data-dc-mm].is-open');
  }

  function bind(item) {
    if (item.__dcMm) return;
    item.__dcMm = true;

    var trigger = item.querySelector('.dc-mm__trigger');
    var timer = null;
    var suppressFocusOpen = false;

    item.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch' || !desktop.matches) return;
      clearTimeout(timer);
      // switching between menus is instant once one is open
      var delay = anyOpen() ? 0 : OPEN_DELAY;
      timer = setTimeout(function () {
        closeAll(item);
        setOpen(item, true);
      }, delay);
    });

    item.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        setOpen(item, false);
      }, CLOSE_DELAY);
    });

    item.addEventListener('focusin', function () {
      if (!desktop.matches || suppressFocusOpen) return;
      clearTimeout(timer);
      closeAll(item);
      setOpen(item, true);
    });

    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) setOpen(item, false);
    });

    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) {
        e.stopPropagation();
        setOpen(item, false);
        suppressFocusOpen = true;
        trigger.focus();
        suppressFocusOpen = false;
      }
    });

    // Touch screens at desktop width: first tap opens the panel, second tap follows the link
    trigger.addEventListener('click', function (e) {
      if (!desktop.matches || canHover.matches) return;
      if (!item.classList.contains('is-open')) {
        e.preventDefault();
        closeAll(item);
        setOpen(item, true);
      }
    });
  }

  function init() {
    allItems().forEach(bind);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dc-mm]')) closeAll();
  });

  desktop.addEventListener('change', function () {
    closeAll();
  });

  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 0);
  });
})();
